import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label
} from 'reactstrap';
import { InputProps } from 'reactstrap/types/lib/Input';
import { useController } from 'react-hook-form';
import React, { useMemo, useState } from 'react';
import Icon from './Icon';
import classnames from 'classnames';

type Props = InputProps & {
  name: string;
  label?: string;
};

const PasswordField = ({ name, label, ...props }: Props) => {
  const [showPassword, setShowPassword] = useState(false);
  const {
    field,
    fieldState: { invalid, error }
  } = useController({ name: name });
  const type = useMemo(() => {
    return showPassword ? 'text' : 'password';
  }, [showPassword]);
  return (
    <FormGroup className="password-field">
      {label && <Label>{label}</Label>}
      <InputGroup>
        <Input {...props} {...field} invalid={invalid} type={type} />
        <Button
          className={classnames('password-eye-toggle', { invalid })}
          color="outline-secondary"
          onClick={() => setShowPassword((x) => !x)}
        >
          <Icon
            icon={showPassword ? 'eye-slash-fill' : 'eye-fill'}
            width={20}
            height={20}
          />
        </Button>
        {error && <FormFeedback>{error.message}</FormFeedback>}
      </InputGroup>
    </FormGroup>
  );
};

export default PasswordField;
